var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('table-daily',{attrs:{"baseUrl":this.baseUrl,"draw":this.draw,"status":this.status,"customerVisitPlanID":this.customerVisitPlanID},on:{"viewCustomer":_vm.handleViewCustomer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }